import React from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import BaseComponent from 'components/BaseComponent';
import styledComp from 'components/StyledComp';

const propTypes = {
  label: PropTypes.string,
  extra: PropTypes.string,
  text: PropTypes.string,
  href: PropTypes.string,
};

const defaultProps = {
  text: '',
  href: '',
};

@autobind
class FormLink extends BaseComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      label,
      extra,
      text,
      href,
      ...layoutProps
    } = this.props;

    return (
      <styledComp.AntdFormItem
        {...layoutProps}
        label={label}
        extra={extra}
      >
        <styledComp.A
          width="wrap_content"
          height="wrap_content"
          href={href}
          target="_blank"
        >
          {text}
        </styledComp.A>
      </styledComp.AntdFormItem>
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
FormLink.propTypes = propTypes;
FormLink.defaultProps = defaultProps;

export default FormLink;
